export const renderIfNotEmpty = (data, children, condition) => {
  const hasData =
    (typeof data === 'string' && data.trim() !== '') ||
    (Array.isArray(data) && data.length > 0) ||
    (typeof data === 'object' &&
      data !== null &&
      !Array.isArray(data) &&
      Object.keys(data).length > 0 &&
      Object.values(data).some(
        val =>
          (typeof val === 'string' && val?.trim() !== '') ||
          (Array.isArray(val) && val.length > 0) ||
          (typeof val === 'object' &&
            val !== null &&
            Object.keys(val).length > 0)
      )) ||
    (typeof condition === 'function' && condition(data))

  return hasData ? children : null
}
